module.exports = __webpack_public_path__ + "img/upmood_band_real1.2e1199ee.png";